import React, { useEffect, useState } from 'react';
import { dataFormat2, mm_rrrr_to_date, pierwszyDzienMiesiaca } from '../../../../functions/dataFormat';
import { zl, isNumber } from '../../../../functions/utilities';

const ZbiorowyKomornikSaldo = (props) => {

    const { czynsze, przelewy_g, saldoStare, sumaCzynszeTenRok, sumaPrzelewyTenRok } = props;

    const [sumaCzynsze, setSumaCzynsze] = useState(0);
    const [sumaPrzelewy, setSumaPrzelewy] = useState(0);

    useEffect( () => {
        let temp = 0;
        temp += przelewy_g?.reduce((acc, obj) => {
            return acc + ( isNumber(obj.kwota) ? obj.kwota : 0 );
        },0);
        setSumaPrzelewy(temp);
    },[przelewy_g])

    useEffect( () => {
        let temp = 0;
        czynsze?.forEach( (c, i) => {
            const czynsz_msc = new Date(mm_rrrr_to_date(c.msc));
            const pierwszy = pierwszyDzienMiesiaca();
            if (czynsz_msc <= pierwszy)
                temp += isNumber( c.czynsz_na_msc ) ? c.czynsz_na_msc : 0;
        })
        setSumaCzynsze(temp);
    },[czynsze]);

    const saldo = sumaPrzelewy - sumaCzynsze;

    let stan = "";
    stan = saldo > 0 ? "nadpłata" : "niedoplata";

    return (
        <section
            style={{
                display: 'flex',
                justifyContent: 'left',
                fontSize: '13px',
                margin: '15mm 10mm 0 0',
                fontWeight: "600",
                lineHeight: "1.5rem"
            }}
        >
            <div>
                <table>
                    <tbody>
                        {/* <tr>
                            <td>
                                {`Saldo na koniec roku ${new Date().getFullYear() - 1}:`}            
                            </td>
                            <td style={{textAlign: "right"}}>
                                {zl(saldoStare)}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {`Suma należności w roku ${new Date().getFullYear()}:`}
                            </td>
                            <td style={{textAlign: "right"}}>
                                {zl(sumaCzynszeTenRok)}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {`Suma wpłat w roku ${new Date().getFullYear()}:`}
                            </td>
                            <td style={{textAlign: "right"}}>
                                {zl(sumaPrzelewyTenRok)}
                            </td>
                        </tr> */}
                        <tr>
                            <td>
                                {`Razem saldo na dzień ${dataFormat2(new Date())}:`}
                            </td>
                            <td style={{textAlign: "right"}}>
                                {`${zl(saldo)}   ${stan}`}
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </section>
    )
}

export default ZbiorowyKomornikSaldo;